/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Базовый вид для списка товаров.
   */
  app.RestItemsView = app.View.extend({
    /**
     * Инициализируем вид для работы с чекбоксами выбора
     */
    initGridView: function () {
      this.childViews.gridHeaderView = new app.GridHeaderView({
        el: $('.catalog-filter'),
        collection: this.model,
        chosenFilters: this.chosenFilters,
        mainWindow: this.mainWindow,
        createNotification: this.createNotification,
        cart: this.cart,
        wishCollection: this.wish,
      });
      this.listenTo(this.childViews.gridHeaderView, 'checkboxes-add', this.checkAll);
      this.listenTo(this.childViews.gridHeaderView, 'checkboxes-remove', this.uncheckAll);
      this.listenTo(this.childViews.gridHeaderView, 'add-checked-in-wish', this.addCheckedInWish);
      this.initRemoveCheckedListener();
      this.listenTo(this.childViews.gridHeaderView, 'add-checked-to-cart', this.addCheckedToCart);
      this.listenTo(Backbone, 'update-grid-buttons', this.updateGridButtons);
      if (!app.isMobile) {
        this.listenTo(this, 'rendered', function () {
          this.updateGridButtons();
          this.updateGridCheckbox();
        });
      }
      this.updateGridCheckbox();
    },
    /**
     * Отдельный метод для инициализации удаления выделенных чекбоксов.
     */
    initRemoveCheckedListener: function () {
      this.listenTo(this.childViews.gridHeaderView, 'remove-checked', this.removeCheckedFromWish);
    },

    /**
     * Обновление состояния кнопки групповых операций.
     */
    updateGridButtons: function () {
      if (!app.isMobile && this.childViews.gridHeaderView) {
        this.childViews.gridHeaderView.updateButtons(Boolean(this.getSelectedItems().length));
        this.childViews.gridHeaderView.setSelectedItemsLength(this.getSelectedItems().length);
      }
    },

    /**
     * Обновление состояния чекбокса выделения всех айтемов
     */
    updateGridCheckbox: function () {
      if (!app.isMobile) {
        this.childViews.gridHeaderView.updateCheckbox(false);
      }
    },

    /**
     * Выбирает из видов только отмеченные чекбоксом.
     * @returns {Array.<T>} Отфильтрованные дочерние виды.
     */
    getSelectedItems: function () {
      return this.childViews.itemViews.filter(function (itemView) {
        return itemView.selected;
      });
    },

    /**
     * Активирует чекбоксы всех товаров.
     */
    checkAll: function () {
      _.each(this.childViews.itemViews, function (itemView) {
        itemView.activate();
      });
      Backbone.trigger('update-grid-buttons');
    },

    /**
     * Деактивирует чекбоксы всех выбранных товаров.
     */
    uncheckAll: function () {
      _.each(this.childViews.itemViews, function (itemView) {
        itemView.deactivate();
      });
      Backbone.trigger('update-grid-buttons');
    },

    /**
     * Извлекает Id продукта из модели
     * @param model Модель из которой извлекается Id продукта
     * @returns {int} Id продукта
     * @protected
     */
    _getItemId: function (model) {
      return model.get('id');
    },

    /**
     * Добавляет отмеченные в избранное.
     */
    addCheckedInWish: function () {
      var ids = [];
      _.each(this.getSelectedItems(), function (item) {
        var id = this._getItemId(item.model);
        if (app.wish.get(id) === undefined) {
          ids.push(id);
        }
      }.bind(this));
      if (!app.user.id) {
        if (ids.length) {
          app.helpers.CookieHelper.setCookie('wishesAfterLogin', ids, {
            domain: '.' + app.helpers.UrlHelper.getDomain(),
            path: '/',
            expires: 450,
          });
        }
          Backbone.trigger(app.CQC_COMMAND_EVENT, {
            type: app.CQC_COMMAND_TYPES.showAuthForm,
          });

      } else {
        app.wish.addByItemIds(ids);
      }
    },
    /**
     * Удаляет отмеченные из избранного.
     */
    removeCheckedFromWish: function () {
      var ids = [],
        selected = this.getSelectedItems();
      _.each(selected, function (itemView) {
          if (app.wish.get(itemView.model.id) !== undefined) {
            ids.push(itemView.model.id);
            itemView.remove();
          }
      });
      app.wish.deleteByItemsIds(ids);
    },
    /**
     *  Добавляет отмеченные в корзину.
     */
    addCheckedToCart: function () {
      var sids = [],
        selected = this.getSelectedItems();
      _.each(selected, function (itemView) {
        sids.push(itemView.model.get('sid'));
      });
      this.cart.addByArticul(sids.toString());
    },

    /**
     * Инициализация динамической доставки товаров.
     */
    initDynamicItemDeliveryCost: function () {
      if (this.isDynamicDeliverySegment) {
        var isCart = this.model instanceof app.Cart,
          view = new app.DynamicItemDeliveryView({
            el: this.$el,
            currency: this.currency,
            itemsCollection: this.model,
            settlement: this.settlement,
            cart: isCart ? this.cart : false,
          });
        if (!isCart) {
          this.listenTo(this, 'rendered', view.initItems.bind(view, { isItemsRender: true }));
        }
        this.childViews.dynamicItemDeliveryView = view;
      }
    }
  });
})();

}.call(window));